// src/pages/NeuerHerstellerPage.jsx
import HerstellerForm from "../components/hersteller/HerstellerForm";

export default function NeuerHerstellerPage() {
  return <HerstellerForm />;
}